type ButtonStyleProps = {
  isDisabled: boolean;
  isReversedColor: boolean;
  isRed: boolean;
  isGreen: boolean;
};

export const createColorButtonStyle = ({
  isDisabled,
  isGreen,
  isRed,
  isReversedColor,
}: Partial<ButtonStyleProps>) => {
  // Adding ! (important) on backgroudn colors because it is overriden by generic tailwind clause
  // I posted in a discussion on their github: https://github.com/tailwindlabs/tailwindcss/discussions/5969

  const isDisabledColors = `bg-slate-300`;
  const classnamesColorBasic = `text-white !bg-blue-700 hover:!bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900`;
  const classnamesColorReversed = `text-blue-800 !bg-white hover:!bg-blue-900 hover:text-white focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900`;
  const classnamesRedColorBasic = `text-white !bg-red-700 hover:!bg-red-800 focus:ring-4 focus:ring-red-300 dark:focus:ring-red-900`;
  const classnamesGreenColorBasic = `text-white !bg-green-700 hover:!bg-green-800 focus:ring-4 focus:ring-green-300 dark:focus:ring-green-900`;

  let colorButton;
  if (isDisabled) {
    colorButton = isDisabledColors;
  } else if (isReversedColor) {
    colorButton = classnamesColorReversed;
  } else if (isRed) {
    colorButton = classnamesRedColorBasic;
  } else if (isGreen) {
    colorButton = classnamesGreenColorBasic;
  } else {
    colorButton = classnamesColorBasic;
  }

  return colorButton;
};

export const createCSSButtonStyle = () => {
  return `inline-flex items-center justify-center px-6 py-3.5 text-base text-center rounded-lg`;
};
